<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview>
                    <template v-slot:body>
                        <div class="row">
                            <div class="col-md-12 offsets-md-6">
                                <router-link :to="{path: '/students/student-list'}">
                                    <b-button variant="outline-danger" class="mt-2 ml-2 float-right">Back</b-button>
                                </router-link>
                                <ButtonComponent colors="#3751E4" name="print" :dataTitleTooltip="'Export To PDF'"
                                    @click.native="downloadAsPDF(pribadi.student_name)" class="mt-2 ml-2 float-right" />
                            </div>
                        </div>
                        <div class="row" id="pdf-content">
                            <div class="col">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="row">
                                            <div class="col p-0" style="text-align: center">
                                                <p class="text-uppercase">
                                                    MARKAS BESAR ANGKATAN DARAT
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: -10px; border-bottom: 1px solid black;">
                                            <div class="col p-0" style="text-align: center">
                                                <p class="text-uppercase">
                                                    AKADEMI MILITER
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-9 float-right">
                                        <div class="row float-right">
                                            <div id="preview" class="mb-2">
                                                <img v-if="pribadi.portrait" :src="pribadi.portrait" height="200" width="200" />
                                                <div v-else style="height: 200px; width: 150px; background-color: #D9D9D9"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="font-weight: 600;">
                                    <div class="col">
                                        <div class="row-md-12" style="text-align: center;">DATA PRIBADI TARUNA/TARUNI TINGKAT IV SERMATUTAR AKADEMIK MILITER </div>
                                        <div class="row-md-12" style="text-align: center;">(data pribadi diisi dengan huruf kapital dan jelas)</div>
                                    </div>
                                    <!-- {{ pribadi }} -->
                                </div>
                                <div class="container mt-5">
                                <h4>I. Data Taruna/Taruni</h4>
                                <table class="ml-5" style="width: 80%;">
                                    <tbody>
                                        <!-- Nama Lengkap -->
                                        <tr>
                                            <td>1. Nama Lengkap</td>
                                            <td colspan="4">: {{ pribadi.student_name ? pribadi.student_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : '-' }}</td>
                                        </tr>

                                        <!-- Noak / Prodi / Cab -->
                                        <tr>
                                            <td>2. Noak / Prodi / Cab</td>
                                            <td>: {{pribadi.nim || '-'}}</td>
                                            <td>/ {{ pribadi.prodi ? pribadi.prodi.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : '-' }}</td>
                                            <td colspan="2">/ {{akademik.nama_cabang || '-'}}</td>
                                        </tr>

                                        <!-- Tempat Lahir -->
                                        <tr>
                                            <td>3. Tempat Lahir</td>
                                            <td>: {{pribadi.pob.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Tanggal Lahir</td>
                                            <td colspan="2"> : {{pribadi.dob??'-'}}</td>
                                        </tr>

                                        <!-- Suku -->
                                        <tr>
                                            <td>4. Suku</td>
                                            <td>: {{pribadi.suku.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Agama</td>
                                            <td colspan="2"> : {{pribadi.religion.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>

                                        <!-- Jenis Kelamin -->
                                        <tr>
                                            <td>5. Jenis Kelamin</td>
                                            <td colspan="5">
                                                <b-form-checkbox-group class="custom-checkbox-group pl-3"  v-model="pribadi.gender" name="gender" :options="genderOptions" :disabled="true" size="lg"></b-form-checkbox-group>
                                            </td>
                                        </tr>
                                        
                                        <!-- NIK -->
                                        <tr>
                                            <td>6. NIK *</td>
                                            <td>: {{pribadi.registration_number.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Kewarganegaraan *</td>
                                            <td colspan="2">: {{pribadi.student_citizenship.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>

                                        <!-- Pendidikan Umum -->
                                        <tr>
                                            <td colspan="6">7. Pendidikan Umum (Diisi lengkap nama pendidikan)</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">a. SD&nbsp;</td>
                                            <td> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'sd')[0]?.institute??'-' }}</td>
                                            <td>Tahun Lulus&nbsp;</td>
                                            <td colspan="2"> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'sd')[0]?.graduation_year??'-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">b. SMP&nbsp;</td>
                                            <td> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'smp')[0]?.institute??'-' }}</td>
                                            <td>Tahun Lulus&nbsp;</td>
                                            <td colspan="2"> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'smp')[0]?.graduation_year??'-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">c. SMA&nbsp;</td>
                                            <td> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'sma')[0]?.institute??'-' }}</td>
                                            <td>Tahun Lulus&nbsp;</td>
                                            <td colspan="2"> : {{ pendidikan.desserts.filter(item => item.degree.toLowerCase() === 'sma')[0]?.graduation_year??'-' }}</td>
                                        </tr>

                                        <!-- Jurusan -->
                                        <tr>
                                            <td class="pl-5">Jurusan</td>
                                            <td colspan="6">
                                                <b-form-checkbox-group v-model="pribadi.jurusan" name="gender" class="custom-checkbox-group pl-3" :options="jurusan" :disabled="true" size="lg"></b-form-checkbox-group>
                                            </td>
                                        </tr>

                                        <!-- Asal Pendaftaran -->
                                        <tr>
                                            <td>8. Asal Pendaftaran</td>
                                            <td colspan="6">: {{ pribadi.asal_pendaftaran.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') ??'-'}}</td>
                                        </tr>

                                        <!-- Anak Keberapa -->
                                        <tr>
                                            <td>9. Anak Keberapa</td>
                                            <td>: {{ pribadi.anak_ke ??'-'}}</td>
                                            <td>dari berapa saudara</td>
                                            <td colspan="2">: {{ pribadi.dari_berapa_sodara ??'-'}}</td>
                                        </tr>
                                        
                                        <!-- Sinyalemen -->
                                        <tr>
                                            <td>10. Sinyalemen</td>
                                            <td>Tinggi Badan</td>
                                            <td>: {{pribadi.height??'-'}}</td>
                                            <td>Berat Badan</td>
                                            <td>: {{pribadi.weight??'-'}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>Warna Mata</td>
                                            <td>: {{pribadi.warna_mata.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Bentuk Mata</td>
                                            <td>: {{pribadi.bentuk_mata.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>Warna Rambut</td>
                                            <td>: {{pribadi.warna_rambut.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Bentuk Rambut</td>
                                            <td>: {{pribadi.bentuk_rambut.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>Warna Kulit</td>
                                            <td>: {{pribadi.warna_kulit.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Golongan Darah</td>
                                            <td>: {{pribadi.blood_type??'-'}}</td>
                                        </tr>
                                        
                                        <!-- Penguasaan Bahasa -->
                                        <tr>
                                            <td>11. Penguasaan Bahasa</td>
                                            <td>Daerah</td>
                                            <td>: {{ pribadi.bahasa_daerah.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                            <td>Asing</td>
                                            <td>: {{ pribadi.bahasa_asing.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>
                                        
                                        <!-- Hobby -->
                                        <tr>
                                            <td>12. Hobby</td>
                                            <td colspan="5">: {{ pribadi.hobi.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>
                                        
                                        <!-- Cita-Cita -->
                                        <tr>
                                            <td>13. Cita-Cita</td>
                                            <td colspan="5">: {{ pribadi.cita_cita.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>

                                        <!-- Alamat -->
                                        <tr>
                                            <td colspan="7">14. Alamat Taruna/Taruni (Sesuai KTP)</td>
                                        </tr>
                                        
                                        <tr>
                                            <td class="pl-5">a. Jalan </td>
                                            <td colspan="4"> : {{ alamat.streets.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">b. Dusun </td>
                                            <td> : {{ alamat?.village.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                            <td>RT : {{ alamat.RT }}</td>
                                            <td colspan="2">RW : {{ alamat.RW }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">c. Kelurahan* </td>
                                            <td> : {{ alamat.kelurahan.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                            <td>Kecamatan* </td>
                                            <td colspan="2"> : {{ alamat.kecamatan.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">d. Kabupaten/Kota* </td>
                                            <td> : {{ alamat.kota.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??alamat.kabupaten.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                            <td>Provinsi* </td>
                                            <td colspan="2"> : {{ alamat.province.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') }}</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">e. Jenis Tinggal</td>
                                            <td colspan="5">
                                                <b-form-checkbox-group v-model="alamat.jenis_tinggal" name="gender" class="custom-checkbox-group pl-3" :options="jenistinggal" size="lg" :disabled="true"></b-form-checkbox-group>
                                            </td>
                                        </tr>

                                        <!-- Telpon Rumah -->
                                        <tr>
                                            <td>15. Telpon Rumah/HP</td>
                                            <td>: {{pribadi.phone_number??'-'}}</td>
                                            <td>Alamat Email</td>
                                            <td colspan="2">: {{pribadi.student_email??'-'}}</td>
                                        </tr>

                                        <!-- Penerima KPS -->
                                        <tr>
                                            <td>16. Penerima KPS*</td>
                                            <td>
                                                <b-form-checkbox-group class="custom-checkbox-group pl-3"  v-model="pribadi.penerima_kps" name="gender" :options="penerimakps" :disabled="true" size="lg"></b-form-checkbox-group>
                                            </td>
                                            <td>Nomor KPS*</td>
                                            <td colspan="2">: {{pribadi.nomor_kps??'-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h4 class="mt-4">III. Data Orang Tua</h4>

                                <!-- Ayah Kandung -->
                                <table class="ml-5">
                                    <tbody>
                                        <tr>
                                            <td colspan="6">1. Ayah Kandung</td>
                                        </tr>
                                        <tr>
                                            <td class="pl-5">a. Nama Lengkap</td>
                                            <td colspan="5">: {{keluarga.name_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>

                                        <!-- Baris dengan 4 kolom -->
                                        <tr>
                                            <td class="pl-5">b. Tempat Lahir</td>
                                            <td>: {{keluarga.tempat_lahir_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Tanggal Lahir</td>
                                            <td colspan="3">: {{ keluarga.dob_a??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">c. Pendidikan</td>
                                            <td>: {{ keluarga.education_a??'-' }}</td>
                                            <td>Pekerjaan</td>
                                            <td>: {{ keluarga.occupation_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                            <td>Instansi</td>
                                            <td>: {{ keluarga.instansi_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>

                                        <!-- Baris dengan 2 kolom -->
                                        <tr>
                                            <td class="pl-5">d. Pangkat/Golongan</td>
                                            <td>: {{ keluarga.tingkat_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                            <td>Jabatan</td>
                                            <td>: {{ keluarga.jabatan_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">e. Penghasilan</td>
                                            <td colspan="5">
                                                <b-form-checkbox-group class="custom-checkbox-group pl-3"  v-model="keluarga.salary_a" name="gender" :options="penghasilan" :disabled="true" size="lg"></b-form-checkbox-group>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">f. Alamat Rumah</td>
                                            <td colspan="5">: {{ keluarga.address_a.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">g. Telp. Rumah / HP</td>
                                            <td colspan="5">: {{ keluarga.phone_a??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td colspan="6">2. Ibu Kandung</td>
                                        </tr>
                                        <!-- Baris dengan 2 kolom -->
                                        <tr>
                                            <td class="pl-5">a. Nama Lengkap</td>
                                            <td colspan="5">: {{keluarga.name_b.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">b. Tempat Lahir</td>
                                            <td>: {{keluarga.tempat_lahir_b.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-'}}</td>
                                            <td>Tanggal Lahir</td>
                                            <td colspan="3">: {{ keluarga.dob_b??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">c. Pendidikan</td>
                                            <td>: {{ keluarga.education_b??'-' }}</td>
                                            <td>Pekerjaan</td>
                                            <td>: {{ keluarga.occupation_b??'-' }}</td>
                                            <td>Instansi</td>
                                            <td>: {{ keluarga.instansi_b??'-' }}</td>
                                        </tr>

                                        <!-- Baris dengan 2 kolom -->
                                        <tr>
                                            <td class="pl-5">d. Pangkat/Golongan</td>
                                            <td>: {{ keluarga.tingkat_b??'-' }}</td>
                                            <td>Jabatan</td>
                                            <td>: {{ keluarga.jabatan_b??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">e. Penghasilan</td>
                                            <td colspan="5">
                                                <b-form-checkbox-group class="custom-checkbox-group pl-3" v-model="keluarga.salary_b" name="gender" :options="penghasilan" :disabled="true" size="lg"></b-form-checkbox-group>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">f. Alamat Rumah</td>
                                            <td colspan="5">: {{ keluarga.address_b.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??'-' }}</td>
                                        </tr>

                                        <tr>
                                            <td class="pl-5">g. Telp. Rumah / HP</td>
                                            <td colspan="5">: {{ keluarga.phone_b??'-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row mt-5 text-center no-gutters">
                                    <div class="col-3 offset-9">
                                        <p>Magelang, {{ getFormattedDate }}</p>
                                    </div>
                                    <div class="col-3 offset-9 d-flex justify-content-center">
                                        <div style="width: 50%; height: 100%; overflow: hidden; display: flex; justify-content: center; align-items: center;">
                                            <img v-if="pribadi.ttd" :src="pribadi.ttd" style="width: 100%; height: auto;" @error="pribadi.ttd = null" />
                                            <div v-else style="height: 100px; width: 100%; background-color: #FFFFFF"></div>
                                        </div>
                                    </div>
                                    <div class="col-3 offset-9">
                                        <p>{{pribadi.student_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')??''}}</p>
                                    </div>
                                    <div class="col-3 offset-9">
                                        <p>Noak. {{pribadi.nim??''}}</p>
                                    </div>
                                </div>
                            </div>

                            </div>
                        </div>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>
<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import html2canvas from 'html2canvas';
import moment from 'moment'
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
    data() {
        return {
            name: null,
            data: [],
            props: this.$route.params.item
                    ? JSON.parse(this.$route.params.item)
                : null,
            url: null,
            genderOptions: [
                { text: 'Laki-Laki', value: 'Laki-laki' },
                { text: 'Perempuan', value: 'Perempuan' }
            ],
            jurusan: [
                { text: 'IPA', value: '1' },
                { text: 'IPS', value: '2' }
            ],
            penerimakps: [
                { text: 'Ya', value: '1' },
                { text: 'Tidak', value: '0' }
            ],
            jenistinggal: [
                { text: 'Bersama Orang tua', value: '1' },
                { text: 'Kost', value: '2' },
                { text: 'Wali', value: '3' },
                { text: 'Asrama', value: '4' },
                { text: 'Panti Asuhan', value: '5' },
                { text: 'Lainnya', value: '6' },
            ],
            penghasilan: [
                { text: 'Kurang dari Rp. 500.000', value: '<500000>' },
                { text: 'Rp. 500.000-Rp.999.999', value: 'p1' },
                { text: 'Rp. 1.000.000-Rp.1.999.999 ', value: '>1000000<199999' },
                { text: 'Rp. 2.000.000-Rp. 4.999.999', value: 'p2' },
                { text: 'Rp. 5.000.000-Rp.20.000.000', value: 'p3' },
                { text: 'Lebih dari Rp. 20.000.000', value: 'p4' },
                { text: 'Tidak Diketahui', value: 'p5' },
            ],
            request:{
                signature : null
            },
            pribadi: {
                portrait: null,
                ttd: null,
                student_name: null,
                registration_number: null,
                nim: null,
                pob: null,
                dob: null,
                status: null,
                student_email: null,
                phone_number: null,
                blood_type: null,
                weight: null,
                height: null,
                student_citizenship: null,
                religion: null,
                marital_status: null,
                gender: null,
                id_user: null,
                awal_penempatan: null,
                nisn: null,
                warna_rambut:null,
                bentuk_rambut:null,
                warna_mata:null,
                bentuk_mata:null,
                warna_kulit:null,
                bahasa_daerah:null,
                hobi:null,
                cita_cita:null,
                anak_ke:null,
                dari_berapa_sodara:null,
                penerima_kps:null,
                nomor_kps:null,
                asal_pendaftaran:null,
                jurusan:null,
                suku:null,
                student_signature : null,
                bahasa_asing:null,
            },
            akademik: {
                nim: null,
                university: null,
                faculty_name: null,
                department_name: null,
                program_name: null,
                enrollment_type: null,
                generation_year: null,
                supervisor: null,
                initial_financing: null,
                generation_name: null,
                phases: null,
                class_type: null,
                enrollment_date: null,
                semester: null,
                study_field: "t",
                status: null,
                batas_studi: null,
                nama_kelompok: null,
                nama_dosen: null,
                nama_cabang: null,
            },
            alamat: {
                streets: null,
                RT: null,
                RW: null,
                kelurahan: null,
                kecamatan: null,
                kota: null,
                province: null,
                kode_pos: null,
                village: null,
                jenis_tinggal: null,
            },
            keluarga: {
                name_a: null,
                email_a: null,
                dob_a: null,
                pob_a: null,
                phone_a: null,
                address_a: null,
                education_a: null,
                city_a: null,
                citizenship_a: null,
                salary_a: null,
                registration_number_a: null,
                occupation_a: null,
                live_state_a: null,
                tempat_lahir_a: null,
                jabatan_a: null,
                instansi_a: null,
                tingkat_a: null,
                name_b: null,
                email_b: null,
                dob_b: null,
                pob_b: null,
                phone_b: null,
                address_b: null,
                education_b: null,
                city_b: null,
                citizenship_b: null,
                salary_b: null,
                registration_number_b: null,
                occupation_b: null,
                live_state_b: null,
                tempat_lahir_b: null,
                jabatan_b: null,
                instansi_b: null,
                tingkat_b: null,
                name_c: null,
                email_c: null,
                dob_c: null,
                phone_c: null,
                address_c: null,
                education_c: null,
                city_c: null,
                citizenship_c: null,
                salary_c: null,
                registration_number_c: null,
                occupation_c: null,
                live_state_c: null,
                tempat_lahir_c: null,
                jabatan_c: null,
                instansi_c: null,
                tingkat_c: null,
            },
            pendidikan: {
                headers: [
                { text: "No", value: "no" },
                { text: "Jenjang Studi", value: "degree" },
                { text: "Nama Institusi", value: "institute" },
                { text: "Tahun Lulus", value: "graduation_year" },
                ],
                desserts: [],
            },
            tingkat: {
                headers: [
                { text: "No", value: "no" },
                { text: "Tingkat", value: "tingkat" },
                { text: "Tanggal", value: "tanggal" },
                ],
                desserts: [],
            },
            pangkat: {
                headers: [
                { text: "No", value: "no" },
                { text: "Pangkat", value: "pangkat" },
                { text: "Tanggal", value: "tanggal" },
                ],
                desserts: [],
            },
        };
    },
    components: {
        KTCodePreview,
        ButtonComponent,
    },
    computed: {
        uuid_siswa() {
            return this.$route.params != null ? this.$route.params.key : null
        },
        getFormattedDate() {
            const today = new Date();
            const day = today.getDate().toString().padStart(2, '0');
            const monthNames = [
                'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
            ];
            const month = monthNames[today.getMonth()]; // getMonth() returns a zero-based index
            const year = today.getFullYear();
            return `${day} ${month} ${year}`;
        },
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Print RH" },
        ]);

        await this.loadData()

    },
    methods: {    
        async loadData(){
        var data1 = this.getDatapribadi();
        var data2 = this.getDataAkademik();
        var data3 = this.getDataAlamat();
        var data4 = this.getDataKeluarga();
        var data5 = this.getDataPendidikan();
        var data6 = this.getDataPangkat();
        var data7 = this.getDataTingkat();

        await Promise.all([data1,data2,data3,data4,data5,data6,data7])
        },

        format_date(value){
            if(value){
                return moment(String(value)).format('DD-MM-YYYY');
            }
        },  

        async handleFileUpload(event){
            try{
                const file  = event.target.files[0];
                this.url    = URL.createObjectURL(file);
                this.file = this.$refs.file.files[0];
                this.klik = true;

                const formData = new FormData();
                formData.append('signature',this.file);

                const res = await axios.post(`master/student/signature/${this.uuid_siswa}`,formData);

                if(res.data.meta.code == 200){
                    this.$swal({
                    title : 'Success upload signature',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#3085d6',
                })
                this.loadData();
                }
               
                
            }catch(err){
                this.$swal(`Failed`);
            }
          
        },

        async getDatapribadi(){
        // data pribadi
        const result = await axios.get(`master/student/${this.uuid_siswa}/detail`);
        
        if (result.data.data.portrait) {
            this.pribadi.portrait = this.$endpoint + 'uploads/student_portrait/' + result.data.data.portrait
        }else{
            this.pribadi.portrait = process.env.BASE_URL + "media/users/default.png";
        }

        if (result.data.data.ttd_path) {
            this.pribadi.ttd = this.$endpoint + 'uploads/student_signature/' + result.data.data.ttd_path
        }else{
            this.pribadi.ttd = null
        }
        this.pribadi.student_name = result.data.data.student_name
        this.pribadi.registration_number = result.data.data.registration_number
        this.pribadi.prodi  = result.data.data.prodi
        this.pribadi.nim    = result.data.data.nim
        this.pribadi.nisn   = result.data.data.nisn
        this.pribadi.pob    = result.data.data.pob
        let dob_non_format  = result.data.data.dob
        this.pribadi.dob    = this.format_date(dob_non_format);
        this.pribadi.status = result.data.data.status
        this.pribadi.awal_penempatan = result.data.data.awal_penempatan
        this.pribadi.student_email = result.data.data.student_email
        this.pribadi.phone_number = (result.data.data.phone_number != 'null') ? result.data.data.phone_number :'-'
        this.pribadi.blood_type = result.data.data.blood_type
        if (this.pribadi.blood_type == 'a') {
            this.pribadi.blood_type = 'A'
        } else if (this.pribadi.blood_type == 'b') {
            this.pribadi.blood_type = 'B'
        } else if (this.pribadi.blood_type == 'o') {
            this.pribadi.blood_type = 'O'
        } else if (this.pribadi.blood_type == 'ab') {
            this.pribadi.blood_type = 'AB'
        }
        this.pribadi.weight = result.data.data.weight
        this.pribadi.height = result.data.data.height
        this.pribadi.student_citizenship = result.data.data.student_citizenship
        this.pribadi.religion = result.data.data.religion_name
        // const result_religion = await axios.get(`master/religion/${this.pribadi.religion}/detail`);
        // this.pribadi.religion = result_religion.data.data.religion_name
        this.pribadi.marital_status = result.data.data.marital_status
        if (this.pribadi.marital_status == 'single') {
            this.pribadi.marital_status = 'Belum Menikah'
        } else if (this.pribadi.marital_status == 'married') {
            this.pribadi.marital_status = 'Menikah'
        }
        this.pribadi.gender = result.data.data.gender
        if (this.pribadi.gender == 'L') {
            this.pribadi.gender = 'Laki-laki'
        } else if (this.pribadi.gender == 'P') {
            this.pribadi.gender = 'Perempuan'
        }
        this.pribadi.id_user = result.data.data.id_user
        this.keyStudent = result.data.data.key
        this.pribadi.warna_rambut = result.data.data.warna_rambut
        this.pribadi.bentuk_rambut = result.data.data.bentuk_rambut
        this.pribadi.warna_mata = result.data.data.warna_mata
        this.pribadi.bentuk_mata = result.data.data.bentuk_mata
        this.pribadi.warna_kulit = result.data.data.warna_kulit
        this.pribadi.bahasa_daerah = result.data.data.bahasa_daerah
        this.pribadi.hobi = result.data.data.hobi
        this.pribadi.cita_cita = result.data.data.cita_cita
        this.pribadi.anak_ke = result.data.data.anak_ke
        this.pribadi.dari_berapa_sodara = result.data.data.dari_berapa_sodara
        this.pribadi.penerima_kps = result.data.data.penerima_kps
        this.pribadi.nomor_kps = result.data.data.nomor_kps
        this.pribadi.asal_pendaftaran = result.data.data.asal_pendaftaran
        this.pribadi.bahasa_asing = result.data.data.bahasa_asing
        this.pribadi.suku               = result.data.data.suku
        this.pribadi.student_signature  = result.data.data.student_signature;
        this.url   = this.$endpoint + 'uploads/student_signature/' + result.data.data.student_signature;
        },

        async getDataAkademik(){
        // data akademik
        const result_academic = await axios.get(`master/student-academic-detail/${this.$route.params.key}/detail-by-student-id`);
        if (result_academic.data.data != null) {
            this.akademik.nim = result_academic.data.data.nim
            this.akademik.nama_kelompok = result_academic.data.data.nama_kelompok
            this.akademik.university = result_academic.data.data.university
            this.akademik.faculty_name = result_academic.data.data.faculty_name
            this.akademik.department_name = result_academic.data.data.department_name
            this.akademik.program_name = result_academic.data.data.program_name
            this.akademik.enrollment_type = result_academic.data.data.enrollment_type
            this.akademik.generation_year = result_academic.data.data.generation_year
            this.akademik.supervisor = result_academic.data.data.supervisor
            this.akademik.nama_cabang = result_academic.data.data.nama_cabang
            this.akademik.initial_financing = result_academic.data.data.initial_financing
            var number_string = this.akademik.initial_financing.replace(/[^,\d]/g, '').toString()
            var split = number_string.split(',')
            var sisa = split[0].length % 3
            var rupiah = split[0].substr(0, sisa)
            var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            if (ribuan) {
            var separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
            }
            this.akademik.initial_financing = rupiah
            // this.akademik.generation_name = result_academic.data.data.generation_year + " / " + result_academic.data.data.tahun_akhir + " - " + result_academic.data.data.generation_semester
            this.akademik.generation_name = result_academic.data.data.nama_angkatan
            this.akademik.phases = result_academic.data.data.phases
            this.akademik.class_type = result_academic.data.data.class_type
            if (this.akademik.class_type == 'kelas1') {
            this.akademik.class_type = 'Kelas 1'
            } else if (this.akademik.class_type == 'kelas2') {
            this.akademik.class_type = 'Kelas 2'
            } else if (this.akademik.class_type == 'kelas3') {
            this.akademik.class_type = 'Kelas 3'
            } else if (this.akademik.class_type == 'kelas4') {
            this.akademik.class_type = 'Kelas 4'
            }
            this.akademik.enrollment_date = result_academic.data.data.enrollment_date
            let date = new Date(this.akademik.enrollment_date)
            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()
            this.akademik.enrollment_date = day + "/" + month + "/" + year
            this.akademik.semester = result_academic.data.data.semester
            this.akademik.study_field = result_academic.data.data.study_field
            // this.akademik.status = result.data.data.status
            this.akademik.batas_studi = result_academic.data.data.batas_studi
            // this.akademik.kelompok = result.data.data.nama_kelompok
            this.akademik.nama_dosen = result_academic.data.data.nama_dosen
        }
        },

        async getDataAlamat(){
        // data alamat
        const result_address = await axios.get(`master/student-address/${this.$route.params.key}/detail-by-student-id`);
        if (result_address.data.data) {
            this.alamat.streets = result_address.data.data.streets
            this.alamat.RT = result_address.data.data.RT
            this.alamat.RW = result_address.data.data.RW
            this.alamat.kelurahan = result_address.data.data.nama_desa_kelurahan
            this.alamat.kecamatan = result_address.data.data.nama_kecamatan
            this.alamat.kota = result_address.data.data.nama_kab_kota
            this.alamat.province = result_address.data.data.nama_provinsi
            this.alamat.kode_pos = result_address.data.data.kode_pos
            this.alamat.village = result_address.data.data.village
            this.alamat.jenis_tinggal = result_address.data.data.jenis_tinggal
        }
        },

        async getDataKeluarga(){
        // data keluarga & wali
        const result_guardian = await axios.get(`master/student-guardian/${this.$route.params.key}/detail-by-student-id`);
        if (result_guardian.data.data) {
            for (var i = 0; i < result_guardian.data.data.length; i++) {
            if (result_guardian.data.data[i].type == 1) {
                this.keluarga.name_a = result_guardian.data.data[i].name
                this.keluarga.email_a = result_guardian.data.data[i].email
                this.keluarga.dob_a = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_a)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_a = day + "/" + month + "/" + year
                this.keluarga.pob_a = result_guardian.data.data[1].pob
                this.keluarga.phone_a = result_guardian.data.data[i].phone
                this.keluarga.address_a = result_guardian.data.data[i].address
                this.keluarga.education_a = result_guardian.data.data[i].education
                this.keluarga.city_a = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_a = result_guardian.data.data[i].citizenship
                this.keluarga.salary_a = result_guardian.data.data[i].salary
                this.keluarga.instansi_a = result_guardian.data.data[i].instansi
                this.keluarga.tingkat_a = result_guardian.data.data[i].tingkat
                // if (this.keluarga.salary_a == 'p1') {
                // this.keluarga.salary_a = '< Rp. 1.000.000'
                // } else if (this.keluarga.salary_a == 'p2') {
                // this.keluarga.salary_a = 'Rp. 1.000.000 - Rp. 5.000.000'
                // } else if (this.keluarga.salary_a == 'p3') {
                // this.keluarga.salary_a = 'Rp. 5.000.000 - Rp. 10.000.000'
                // } else if (this.keluarga.salary_a == 'p4') {
                // this.keluarga.salary_a = '> Rp. 10.000.000'
                // }
                this.keluarga.registration_number_a = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_a = result_guardian.data.data[i].occupation
                this.keluarga.tempat_lahir_a = result_guardian.data.data[i].tempat_lahir
                this.keluarga.jabatan_a = result_guardian.data.data[i].jabatan
                if (this.keluarga.occupation_a == 'pe1') {
                this.keluarga.occupation_a = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_a == 'pe2') {
                this.keluarga.occupation_a = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_a == 'pe3') {
                this.keluarga.occupation_a = 'Dokter'
                } else if (this.keluarga.occupation_a == 'pe4') {
                this.keluarga.occupation_a = 'Freelance'
                }
                this.keluarga.live_state_a = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_a == 's1') {
                this.keluarga.live_state_a = 'Hidup'
                } else {
                this.keluarga.live_state_a = 'Meninggal'
                }
            } else if (result_guardian.data.data[i].type == 2) {
                this.keluarga.name_b = result_guardian.data.data[i].name
                this.keluarga.email_b = result_guardian.data.data[i].email
                this.keluarga.dob_b = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_b)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_b = day + "/" + month + "/" + year
                this.keluarga.pob_b = result_guardian.data.data[1].pob
                this.keluarga.phone_b = result_guardian.data.data[i].phone
                this.keluarga.address_b = result_guardian.data.data[i].address
                this.keluarga.education_b = result_guardian.data.data[i].education
                this.keluarga.city_b = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_b = result_guardian.data.data[i].citizenship
                this.keluarga.salary_b = result_guardian.data.data[i].salary
                this.keluarga.instansi_b = result_guardian.data.data[i].instansi
                this.keluarga.tingkat_b = result_guardian.data.data[i].tingkat
                // if (this.keluarga.salary_b == 'p1') {
                // this.keluarga.salary_b = '< Rp. 1.000.000'
                // } else if (this.keluarga.salary_b == 'p2') {
                // this.keluarga.salary_b = 'Rp. 1.000.000 - Rp. 5.000.000'
                // } else if (this.keluarga.salary_b == 'p3') {
                // this.keluarga.salary_b = 'Rp. 5.000.000 - Rp. 10.000.000'
                // } else if (this.keluarga.salary_b == 'p4') {
                // this.keluarga.salary_b = '> Rp. 10.000.000'
                // }
                this.keluarga.registration_number_b = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_b = result_guardian.data.data[i].occupation
                if (this.keluarga.occupation_b == 'pe1') {
                this.keluarga.occupation_b = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_b == 'pe2') {
                this.keluarga.occupation_b = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_b == 'pe3') {
                this.keluarga.occupation_b = 'Dokter'
                } else if (this.keluarga.occupation_b == 'pe4') {
                this.keluarga.occupation_b = 'Freelance'
                }
                this.keluarga.live_state_b = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_b == 's1') {
                this.keluarga.live_state_b = 'Hidup'
                } else {
                this.keluarga.live_state_b = 'Meninggal'
                }
                this.keluarga.tempat_lahir_b = result_guardian.data.data[i].tempat_lahir
                this.keluarga.jabatan_b = result_guardian.data.data[i].jabatan
            } else if (result_guardian.data.data[i].type == 3) {
                this.keluarga.name_c = result_guardian.data.data[i].name
                this.keluarga.email_c = result_guardian.data.data[i].email
                this.keluarga.dob_c = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_c)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_c = day + "/" + month + "/" + year
                this.keluarga.phone_c = result_guardian.data.data[i].phone
                this.keluarga.address_c = result_guardian.data.data[i].address
                this.keluarga.education_c = result_guardian.data.data[i].education
                this.keluarga.city_c = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_c = result_guardian.data.data[i].citizenship
                this.keluarga.salary_c = result_guardian.data.data[i].salary
                this.keluarga.instansi_c = result_guardian.data.data[i].instansi
                this.keluarga.tingkat_c = result_guardian.data.data[i].tingkat
                if (this.keluarga.salary_c == 'p1') {
                this.keluarga.salary_c = '< Rp. 1.000.000'
                } else if (this.keluarga.salary_c == 'p2') {
                this.keluarga.salary_c = 'Rp. 1.000.000 - Rp. 5.000.000'
                } else if (this.keluarga.salary_c == 'p3') {
                this.keluarga.salary_c = 'Rp. 5.000.000 - Rp. 10.000.000'
                } else if (this.keluarga.salary_c == 'p4') {
                this.keluarga.salary_c = '> Rp. 10.000.000'
                }
                this.keluarga.registration_number_c = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_c = result_guardian.data.data[i].occupation
                if (this.keluarga.occupation_c == 'pe1') {
                this.keluarga.occupation_c = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_c == 'pe2') {
                this.keluarga.occupation_c = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_c == 'pe3') {
                this.keluarga.occupation_c = 'Dokter'
                } else if (this.keluarga.occupation_c == 'pe4') {
                this.keluarga.occupation_c = 'Freelance'
                }
                this.keluarga.live_state_c = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_c == 's1') {
                this.keluarga.live_state_c = 'Hidup'
                } else {
                this.keluarga.live_state_c = 'Meninggal'
                }
                this.keluarga.tempat_lahir_c = result_guardian.data.data[i].tempat_lahir
                this.keluarga.jabatan_c = result_guardian.data.data[i].jabatan
            }
            }
        }
        },

        async getDataPendidikan(){
        // data pendidikan
        const result_education = await axios.get(`master/student-education/${this.uuid_siswa}/detail-by-student-id`);
        if (result_education.data.meta.code == 200) {
            this.pendidikan.desserts = result_education.data.data 
            this.pribadi.jurusan = result_education.data.data.filter(item => item.degree.toLowerCase() === 'sma')[0]?.jurusan??'-';
        }
        },

        async getDataPangkat(){
        // data pangkat
        const riwayatPangkat = await axios.get(`alumni-new/riwayat-pangkat/${this.uuid_siswa}`);
        riwayatPangkat.data.data.map((riwayats, index) => {
            let date = new Date(riwayats.tanggal_pangkat)
            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()
            var tanggal_pengesahan_pangkat = day + "/" + month + "/" + year
            let riwayat_pa = {
            no: index + 1, 
            pangkat: riwayats.nama_pangkat, 
            tanggal: tanggal_pengesahan_pangkat
            }
            this.pangkat.desserts.push(riwayat_pa);
        })
        },
        
        async getDataTingkat(){
        const riwayatTingkat = await axios.get(`alumni-new/riwayat-tingkat/${this.uuid_siswa}`);
        riwayatTingkat.data.data.map((riwayats, index) => {
            let datet = new Date(riwayats.tanggal_tingkat)
            let dayt = datet.getDate()
            let montht = datet.getMonth() + 1
            let yeart = datet.getFullYear()
            var tanggal_pengesahan_tingkat = dayt + "/" + montht + "/" + yeart
            let riwayat_t = {
            no: index + 1, 
            tingkat: riwayats.tingkat, 
            tanggal: tanggal_pengesahan_tingkat
            }
            this.tingkat.desserts.push(riwayat_t);
        })
        },
        async getData() {
            // data pribadi
            const result = await axios.get(`master/student/${this.uuid_siswa}/detail`);
            if (result.data.data.portrait === undefined || result.data.data.portrait === null ) {
                this.pribadi.portrait = null
            }else if (result.data.data.portrait != "") {
                this.pribadi.portrait = this.$endpoint + 'uploads/student_portrait/' + result.data.data.portrait
            }
            this.pribadi.student_name = result.data.data.student_name
            this.pribadi.registration_number = result.data.data.registration_number
            this.pribadi.nim = result.data.data.nim
            this.pribadi.nisn = result.data.data.nisn
            this.pribadi.pob = result.data.data.pob
            const month = ["Januari","Februari","Maret","April","Mei","Juni","Juli", "Agustus", "September", "Oktober", "November", "Desember"];
            let tgl_temp = new Date(result.data.data.dob)
            this.pribadi.dob = tgl_temp.getDate() + ' ' + month[tgl_temp.getMonth()] + ' ' + tgl_temp.getFullYear()
            this.pribadi.status = result.data.data.status
            this.pribadi.awal_penempatan = result.data.data.awal_penempatan
            this.pribadi.student_email = result.data.data.student_email
            this.pribadi.phone_number = result.data.data.phone_number
            this.pribadi.blood_type = result.data.data.blood_type
            if (this.pribadi.blood_type == 'a') {
            this.pribadi.blood_type = 'A'
            } else if (this.pribadi.blood_type == 'b') {
            this.pribadi.blood_type = 'B'
            } else if (this.pribadi.blood_type == 'o') {
            this.pribadi.blood_type = 'O'
            } else if (this.pribadi.blood_type == 'ab') {
            this.pribadi.blood_type = 'AB'
            }
            this.pribadi.weight = result.data.data.weight
            this.pribadi.height = result.data.data.height
            this.pribadi.student_citizenship = result.data.data.student_citizenship
            this.pribadi.religion = result.data.data.religion_name
            // const result_religion = await axios.get(`master/religion/${this.pribadi.religion}/detail`);
            // this.pribadi.religion = result_religion.data.data.religion_name
            this.pribadi.marital_status = result.data.data.marital_status
            if (this.pribadi.marital_status == 'single') {
            this.pribadi.marital_status = 'Belum Menikah'
            } else if (this.pribadi.marital_status == 'married') {
            this.pribadi.marital_status = 'Menikah'
            }
            this.pribadi.gender = result.data.data.gender
            if (this.pribadi.gender == 'L') {
            this.pribadi.gender = 'Laki-laki'
            } else if (this.pribadi.gender == 'P') {
            this.pribadi.gender = 'Perempuan'
            }
            this.pribadi.id_user = result.data.data.id_user

            // data akademik
            const result_academic = await axios.get(`master/student-academic-detail/${result.data.data.key}/detail-by-student-id`);
            if (result_academic.data.data != null) {
            this.akademik.nim   = result_academic.data.data.nim
            this.akademik.nama_kelompok = result_academic.data.data.nama_kelompok
            this.akademik.university = result_academic.data.data.university
            this.akademik.faculty_name = result_academic.data.data.faculty_name
            this.akademik.department_name = result_academic.data.data.department_name
            this.akademik.program_name = result_academic.data.data.program_name.toUpperCase()
            this.akademik.enrollment_type = result_academic.data.data.enrollment_type
            this.akademik.generation_year = result_academic.data.data.generation_year
            this.akademik.supervisor = result_academic.data.data.supervisor
            this.akademik.nama_cabang = result_academic.data.data.nama_cabang
            this.akademik.initial_financing = result_academic.data.data.initial_financing
            // var number_string = this.akademik.initial_financing.replace(/[^,\d]/g, '').toString()
            // var split = number_string.split(',')
            // var sisa = split[0].length % 3
            // var rupiah = split[0].substr(0, sisa)
            // var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            // if (ribuan) {
            //     var separator = sisa ? '.' : '';
            //     rupiah += separator + ribuan.join('.');
            // }
            // this.akademik.initial_financing = rupiah
            this.akademik.generation_name = result_academic.data.data.generation_year + " / " + result_academic.data.data.tahun_akhir + " - " + result_academic.data.data.generation_semester
            let num = result_academic.data.data.nama_angkatan
            var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
            for ( i in lookup ) {
                while ( num >= lookup[i] ) {
                roman += i;
                num -= lookup[i];
                }
            }
            this.akademik.generation_name = roman
            // this.akademik.generation_name = result_academic.data.data.nama_angkatan
            this.akademik.phases = result_academic.data.data.phases
            this.akademik.class_type = result_academic.data.data.class_type
            if (this.akademik.class_type == 'kelas1') {
                this.akademik.class_type = 'Kelas 1'
            } else if (this.akademik.class_type == 'kelas2') {
                this.akademik.class_type = 'Kelas 2'
            } else if (this.akademik.class_type == 'kelas3') {
                this.akademik.class_type = 'Kelas 3'
            } else if (this.akademik.class_type == 'kelas4') {
                this.akademik.class_type = 'Kelas 4'
            }
            this.akademik.enrollment_date = result_academic.data.data.enrollment_date
            let date = new Date(this.akademik.enrollment_date)
            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()
            this.akademik.enrollment_date = day + "/" + month + "/" + year
            this.akademik.semester = result_academic.data.data.semester
            this.akademik.study_field = result_academic.data.data.study_field
            this.akademik.status = result.data.data.status
            this.akademik.batas_studi = result_academic.data.data.batas_studi
            this.akademik.kelompok = result.data.data.nama_kelompok
            this.akademik.nama_dosen = result_academic.data.data.nama_dosen
            }

            // data alamat
            const result_address = await axios.get(`master/student-address/${result.data.data.key}/detail-by-student-id`);
            if (result_address.data.data != null) {
            this.alamat.streets = result_address.data.data.streets
            this.alamat.RT = result_address.data.data.RT
            this.alamat.RW = result_address.data.data.RW
            this.alamat.kelurahan = result_address.data.data.nama_desa_kelurahan
            this.alamat.kecamatan = result_address.data.data.nama_kecamatan
            this.alamat.kota = result_address.data.data.nama_kab_kota
            this.alamat.province = result_address.data.data.nama_provinsi
            this.alamat.kode_pos = result_address.data.data.kode_pos
            }

            // data keluarga & wali
            const result_guardian = await axios.get(`master/student-guardian/${result.data.data.key}/detail-by-student-id`);
            if (result_guardian!= null) {
            for (i = 0; i < result_guardian.data.data.length; i++) {
                if (result_guardian.data.data[i].type == 1) {
                this.keluarga.name_a = result_guardian.data.data[i].name
                this.keluarga.email_a = result_guardian.data.data[i].email
                this.keluarga.dob_a = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_a)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_a = day + "/" + month + "/" + year
                this.keluarga.phone_a = result_guardian.data.data[i].phone
                this.keluarga.address_a = result_guardian.data.data[i].address
                this.keluarga.education_a = result_guardian.data.data[i].education
                this.keluarga.city_a = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_a = result_guardian.data.data[i].citizenship
                this.keluarga.salary_a = result_guardian.data.data[i].salary
                if (this.keluarga.salary_a == 'p1') {
                    this.keluarga.salary_a = '< Rp. 1.000.000'
                } else if (this.keluarga.salary_a == 'p2') {
                    this.keluarga.salary_a = 'Rp. 1.000.000 - Rp. 5.000.000'
                } else if (this.keluarga.salary_a == 'p3') {
                    this.keluarga.salary_a = 'Rp. 5.000.000 - Rp. 10.000.000'
                } else if (this.keluarga.salary_a == 'p4') {
                    this.keluarga.salary_a = '> Rp. 10.000.000'
                }
                this.keluarga.registration_number_a = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_a = result_guardian.data.data[i].occupation
                if (this.keluarga.occupation_a == 'pe1') {
                    this.keluarga.occupation_a = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_a == 'pe2') {
                    this.keluarga.occupation_a = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_a == 'pe3') {
                    this.keluarga.occupation_a = 'Dokter'
                } else if (this.keluarga.occupation_a == 'pe4') {
                    this.keluarga.occupation_a = 'Freelance'
                }
                this.keluarga.live_state_a = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_a == 's1') {
                    this.keluarga.live_state_a = 'Hidup'
                } else {
                    this.keluarga.live_state_a = 'Meninggal'
                }
                } else if (result_guardian.data.data[i].type == 2) {
                this.keluarga.name_b = result_guardian.data.data[i].name
                this.keluarga.email_b = result_guardian.data.data[i].email
                this.keluarga.dob_b = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_b)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_b = day + "/" + month + "/" + year
                this.keluarga.phone_b = result_guardian.data.data[i].phone
                this.keluarga.address_b = result_guardian.data.data[i].address
                this.keluarga.education_b = result_guardian.data.data[i].education
                this.keluarga.city_b = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_b = result_guardian.data.data[i].citizenship
                this.keluarga.salary_b = result_guardian.data.data[i].salary
                if (this.keluarga.salary_b == 'p1') {
                    this.keluarga.salary_b = '< Rp. 1.000.000'
                } else if (this.keluarga.salary_b == 'p2') {
                    this.keluarga.salary_b = 'Rp. 1.000.000 - Rp. 5.000.000'
                } else if (this.keluarga.salary_b == 'p3') {
                    this.keluarga.salary_b = 'Rp. 5.000.000 - Rp. 10.000.000'
                } else if (this.keluarga.salary_b == 'p4') {
                    this.keluarga.salary_b = '> Rp. 10.000.000'
                }
                this.keluarga.registration_number_b = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_b = result_guardian.data.data[i].occupation
                if (this.keluarga.occupation_b == 'pe1') {
                    this.keluarga.occupation_b = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_b == 'pe2') {
                    this.keluarga.occupation_b = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_b == 'pe3') {
                    this.keluarga.occupation_b = 'Dokter'
                } else if (this.keluarga.occupation_b == 'pe4') {
                    this.keluarga.occupation_b = 'Freelance'
                }
                this.keluarga.live_state_b = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_b == 's1') {
                    this.keluarga.live_state_b = 'Hidup'
                } else {
                    this.keluarga.live_state_b = 'Meninggal'
                }
                } else if (result_guardian.data.data[i].type == 3) {
                this.keluarga.name_c = result_guardian.data.data[i].name
                this.keluarga.email_c = result_guardian.data.data[i].email
                this.keluarga.dob_c = result_guardian.data.data[i].dob
                let date = new Date(this.keluarga.dob_c)
                let day = date.getDate()
                let month = date.getMonth() + 1
                let year = date.getFullYear()
                this.keluarga.dob_c = day + "/" + month + "/" + year
                this.keluarga.phone_c = result_guardian.data.data[i].phone
                this.keluarga.address_c = result_guardian.data.data[i].address
                this.keluarga.education_c = result_guardian.data.data[i].education
                this.keluarga.city_c = result_guardian.data.data[i].nama_kab_kota
                this.keluarga.citizenship_c = result_guardian.data.data[i].citizenship
                this.keluarga.salary_c = result_guardian.data.data[i].salary
                if (this.keluarga.salary_c == 'p1') {
                    this.keluarga.salary_c = '< Rp. 1.000.000'
                } else if (this.keluarga.salary_c == 'p2') {
                    this.keluarga.salary_c = 'Rp. 1.000.000 - Rp. 5.000.000'
                } else if (this.keluarga.salary_c == 'p3') {
                    this.keluarga.salary_c = 'Rp. 5.000.000 - Rp. 10.000.000'
                } else if (this.keluarga.salary_c == 'p4') {
                    this.keluarga.salary_c = '> Rp. 10.000.000'
                }
                this.keluarga.registration_number_c = result_guardian.data.data[i].registration_number
                this.keluarga.occupation_c = result_guardian.data.data[i].occupation
                if (this.keluarga.occupation_c == 'pe1') {
                    this.keluarga.occupation_c = 'Pegawai Negeri'
                } else if (this.keluarga.occupation_c == 'pe2') {
                    this.keluarga.occupation_c = 'Pegawai Swasta'
                } else if (this.keluarga.occupation_c == 'pe3') {
                    this.keluarga.occupation_c = 'Dokter'
                } else if (this.keluarga.occupation_c == 'pe4') {
                    this.keluarga.occupation_c = 'Freelance'
                }
                this.keluarga.live_state_c = result_guardian.data.data[i].live_state
                if (this.keluarga.live_state_c == 's1') {
                    this.keluarga.live_state_c = 'Hidup'
                } else {
                    this.keluarga.live_state_c = 'Meninggal'
                }
                }
            }
            }

            // data pendidikan
            const result_education = await axios.get(`master/student-education/${result.data.data.key}/detail-by-student-id`);
            if (result_education.data.meta.code == 200) {
            this.pendidikan.desserts = result_education.data.data
            }

            // data pangkat
            // const riwayatPangkat = await axios.get(`master/promotion/${this.uuid_siswa}/student`);
            // riwayatPangkat.data.data.map((riwayats, index) => {
            // let date = new Date(riwayats.tanggal_pengesahan_pangkat)
            // let day = date.getDate()
            // let month = date.getMonth() + 1
            // let year = date.getFullYear()
            // riwayats.tanggal_pengesahan_pangkat = day + "/" + month + "/" + year
            // let riwayat_pa = {
            //     no: index + 1, 
            //     pangkat: riwayats.nama_pangkat, 
            //     tanggal: riwayats.tanggal_pengesahan_pangkat
            // }
            // this.pangkat.desserts.push(riwayat_pa);
            // })
            // riwayatPangkat.data.data.map((riwayats, index) => {
            // let date = new Date(riwayats.tanggal_pengesahan_tingkat)
            // let day = date.getDate()
            // let month = date.getMonth() + 1
            // let year = date.getFullYear()
            // riwayats.tanggal_pengesahan_tingkat = day + "/" + month + "/" + year
            // let riwayat_t = {
            //     no: index + 1, 
            //     tingkat: riwayats.tingkat, 
            //     tanggal: riwayats.tanggal_pengesahan_tingkat
            // }
            // this.tingkat.desserts.push(riwayat_t);
            // })
        }, 
        async downloadAsPDF(name) {
            //     const divToPrint = document.getElementById('pdf-content');
            // Testing break page
            // Get the content of each page by its ID
            const page1 = document.getElementById('pdf-content');
            // const page2 = document.getElementById('pdf-content2');

            // Create canvases for each page
            html2canvas(page1).then((canvas) => {
                const image1 = canvas.toDataURL('uploads/student_portrait/');
                const documentDefinition = {
                    content: [
                        { image: image1, width: 500, alignment: 'center', },
                        // { text: '\n\n' }, // Add space between pages
                        { text: '', pageBreak: 'before' },
                        // { image: image2, width: 500, alignment: 'center', },
                        // Add more pages as needed
                    ],
                    pageSize: 'A4', // Set a fixed paper size (A4 in this case)
                    pageMargins: [5, 10, 5, 10], // Set fixed page margins [left, top, right, bottom]
                };
                // Buat PDF
                pdfMake.createPdf(documentDefinition).download(`RH-${name}.pdf`);
            })
            // const canvas2 = await html2canvas(page2);

            // Convert canvases to images
            // const image2 = canvas2.toDataURL('media/logos/');

            // Define the document content

            // Create the PDF
            // const pdfDoc = pdfMake.createPdf(documentDefinition);

            // Open the PDF in a new tab or download it
            // pdfDoc.open();
            // pdfDoc.download(`RH-${name}.pdf`);
        },
        async printData() {

            // var printContents = document.getElementById('pdf-content').innerHTML;
            // document.body.innerHTML = printContents;
            // window.print();
            // const content = document.getElementById('pdf-content');
            // html2pdf(content)
            //     .from(content)
            //     .save('document.pdf');
        },


    },
};
</script>
<style>
#pdf-content {
    font-family: 'Arial', sans-serif;
    /* Set your desired font-family */
    font-size: 20px;
    /* Set your desired font-size */
}

#pdf-content2 {
    font-family: 'Arial', sans-serif;
    /* Set your desired font-family */
    font-size: 20px;
    /* Set your desired font-size */
}

/* Style the td to ensure the content is aligned correctly */
/* Ensure the table cell keeps everything on the same line */
td {
    white-space: nowrap;
}

/* Style the custom checkbox group for horizontal alignment */
.custom-checkbox-group {
    display: flex;
    flex-wrap: wrap; /* Allow checkboxes to wrap to a new line */
    align-items: center;
}

.custom-checkbox-group .b-form-checkbox {
    width: calc(33.33% - 20px); /* Adjust the width so that 3 items fit per row */
    margin-right: 15px; /* Space between checkboxes */
    margin-bottom: 10px; /* Space below each checkbox to separate rows */
}

.custom-checkbox-group .b-form-checkbox-label {
    margin-left: 5px; /* Space between checkbox and label */
    font-size: 18px; /* Adjust text size */
}



.card-krs {
    border-left: 2px solid #485377;
}

.card-krs span {
    color: #485377;
    font-size: initial;
}

.card-krs p {
    color: #485377;
    font-weight: 700;
    font-size: initial;
}

.header-krs-color {
    background-color: #3751E4 !important;
    color: white !important;
    font-size: medium !important;
    font-weight: 500 !important;
}

.v-card-krs>*:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),
.v-card>.v-card__progress+*:not(.v-btn):not(.v-chip):not(.v-avatar) {
    border-top: 1px solid #485377;
}

.border-krs {
    border-top: 2px solid #3751E4;
    border-bottom: 2px solid #3751E4;
}

.p-krs {
    margin: 2px 0px 0px 20px;
    font-weight: 700;
    color: #485377;
    font-size: initial;
}

/* tr { border: 2px solid red; } */
.color-font {
    color: #485377;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    font-size: small;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>th {
    font-size: small;
}

.btn-krs {
    /* width: 40px;
  height: 40px; */
    background-color: #3751E4 !important;
    margin-right: 2%;
    color: white !important;
    font-weight: 600;
}

.fnt {
    font-size: 1.2rem;
    font-weight: bold;
}

.my-element {
    width: 100%;
    /* Default to 100% width */
    height: auto;
}

/* Styles for large screens (Xl) */
@media (min-width: 2560px) {
    .my-element {
        width: 30%;
        /* Adjust to 25% width on large screens */
        height: auto;
    }
}

/* Styles for large screens (lg) */
@media (max-width: 2559px) {
    .my-element {
        width: 40%;
        /* Adjust to 25% width on large screens */
        height: auto;
    }
}

/* Styles for medium-sized screens (md) */
@media (max-width: 1199px) {
    .my-element {
        width: 80%;
        /* Adjust to 50% width on medium-sized screens */
        height: auto;
    }
}</style>
  